import React, { useState, useEffect } from "react";
import { Ptag, MainBody, OverlayLoader } from "components/core";
import http from "services/httpService";
import CdbalanceCard from "components/CdBalance/CdBalanceCard";
import { CardTag } from "pages/ViewUpdateCd/styles";
import useUser from "hooks/useUser";
import CDBalandeForRM from "./CDBalandeForRM";

const CashDeposit = () => {
  const flexProduct = 1;
  const [loading, setLoading] = useState(true);
  const [ledgerTable, setLedgerTable] = useState([]);

  const { getRole } = useUser();
  const role = getRole();

  useEffect(() => {
    (async function () {
      await getData();
    })();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(`/business/view_cd_balance/`, {
        params: {
          business_user_id: localStorage.getItem("id"),
        },
      });

      setLedgerTable(Object.entries(data));
      setLoading(false);
    } catch (ex) {
      setLoading(false);
    }
  };
  const renderCard = () => {
    let planKey;
    if (flexProduct === 1) {
      planKey = JSON.parse(localStorage.getItem("flex_products_list"));
    } else {
      planKey = Object.keys(ledgerTable).sort((a, b) => {
        if (a.slice(0, 3) < b.slice(0, 3)) {
          return -1;
        } else if (a.slice(0, 3) > b.slice(0, 3)) {
          return 1;
        } else {
          return a.length < b.length ? -1 : 1;
        }
      });
    }
    return (
      ledgerTable &&
      ledgerTable.map(([key, value]) => (
        <CdbalanceCard planType={key} tableData={value} key={key} />
      ))
    );
  };

  const renderCDBalanceJSX = () => {
    if(role==="admin") {
      return (
        <section>
        <Ptag fontSize="16px" fontWeight="400" letterHeight="22px" fontFamily="Montserrat">
          A mandatory non-interest bearing CD account is created to deposit all
          premium payments and manage insurance related transactions with the
          insurer.
        </Ptag>
        <CardTag>{renderCard()}</CardTag>
      </section>
      )
    } else {
      return <CDBalandeForRM />
    }
  }

  // const lastUpdatedCd = () => {
  //   return (
  //     <section>
  //       <Ptag fontSize="16px" fontWeight="400" letterHeight="22px">
  //         A mandatory non-interest bearing CD account is created to deposit all
  //         premium payments and manage insurance related transactions with the
  //         insurer.
  //       </Ptag>
  //       <CardTag>{renderCard()}</CardTag>
  //     </section>
  //   );
  // };

  if (loading) return <OverlayLoader />;

  // return <>{lastUpdatedCd()}</>;
  return <>{renderCDBalanceJSX()}</>;
};
// }

export default CashDeposit;
